import React from 'react';

const PRESETS = {
  // Project lifecycle / health
  'In Progress': {
    wrap: 'bg-primary-50 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300',
    dot: 'bg-primary-500',
  },
  'On Time': {
    wrap: 'bg-primary-50 text-primary-700 dark:bg-primary-900/40 dark:text-primary-300',
    dot: 'bg-primary-500',
  },
  // Soft blue variant used for task rows (matches mockup task pills)
  'In Progress Soft': {
    wrap: 'bg-sky-50 text-sky-700 dark:bg-sky-900/40 dark:text-sky-300',
    dot: 'bg-sky-500',
  },
  'On Hold': {
    wrap: 'bg-amber-50 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
    dot: 'bg-amber-500',
  },
  Delayed: {
    wrap: 'bg-amber-50 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
    dot: 'bg-amber-500',
  },
  'At Risk': {
    wrap: 'bg-orange-50 text-orange-700 dark:bg-orange-900/40 dark:text-orange-300',
    dot: 'bg-orange-500',
  },
  Completed: {
    wrap: 'bg-green-50 text-green-700 dark:bg-green-900/40 dark:text-green-300',
    dot: 'bg-green-500',
  },
  Complete: {
    wrap: 'bg-green-50 text-green-700 dark:bg-green-900/40 dark:text-green-300',
    dot: 'bg-green-500',
  },
  Done: {
    wrap: 'bg-green-50 text-green-700 dark:bg-green-900/40 dark:text-green-300',
    dot: 'bg-green-500',
  },
  'Not Started': {
    wrap: 'bg-secondary-100 text-secondary-600 dark:bg-secondary-700 dark:text-secondary-300',
    dot: 'bg-secondary-400',
  },
  Planning: {
    wrap: 'bg-secondary-100 text-secondary-600 dark:bg-secondary-700 dark:text-secondary-300',
    dot: 'bg-secondary-400',
  },
  'To Do': {
    wrap: 'bg-secondary-100 text-secondary-700 dark:bg-secondary-700 dark:text-secondary-200',
    dot: 'bg-secondary-400',
  },
  Unknown: {
    wrap: 'bg-secondary-100 text-secondary-600 dark:bg-secondary-700 dark:text-secondary-300',
    dot: 'bg-secondary-400',
  },
  Manual: {
    wrap: 'bg-amber-50 text-amber-700 dark:bg-amber-900/40 dark:text-amber-300',
    dot: 'bg-amber-500',
  },
  Tracked: {
    wrap: 'bg-green-50 text-green-700 dark:bg-green-900/40 dark:text-green-300',
    dot: 'bg-green-500',
  },
};

/**
 * Soft status pill with optional leading dot (Projects/Tasks tables).
 */
const StatusPill = ({ status, colorClass, showDot = true, className = '', label: labelOverride }) => {
  const key = status || 'Unknown';
  const preset = PRESETS[key];
  const wrap = colorClass || preset?.wrap || PRESETS.Unknown.wrap;
  const dot = preset?.dot || 'bg-secondary-400';
  const label = labelOverride || (key === 'In Progress Soft' ? 'In Progress' : key);

  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium whitespace-nowrap ${wrap} ${className}`}
    >
      {showDot && <span className={`h-1.5 w-1.5 rounded-full flex-shrink-0 ${dot}`} />}
      {label}
    </span>
  );
};

export default StatusPill;
